import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {firstValueFrom, Observable} from 'rxjs';
import {Store} from '@ngxs/store';
import {UserAction, UserState} from '../../models/user';
import {IClinic} from '../../models/clinic';
import {StorageService} from '../../services/storage/storage.service';
import {AuthActions, IUser} from '../../models/auth';
import {PatientStatusEnum} from '../../models/patient';

@Injectable({
  providedIn: 'root'
})
export class BelongToTheClinicGuard implements CanActivateChild {
  constructor(
    private store: Store,
    private router: Router,
    private storageService: StorageService,
  ) { }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise<boolean>(async (resolve: (value: boolean) => any, reject: (reason: boolean) => any) => {

      try {
        const paramClinicId = childRoute.params.clinicId;
        let clinics = this.store.selectSnapshot(UserState.getUserClinics);
        const token = this.storageService.getLocalItem<{ user: IUser, token: string }>('user')?.token;
        if ((!clinics || clinics.length === 0) && token) {
          await firstValueFrom((this.store.dispatch(new UserAction.GetOwnerClinics())));
          clinics = this.store.selectSnapshot(UserState.getUserClinics);
        }
        if (!paramClinicId || clinics.length === 0) {
          await this.router.navigate(['auth/new/landing']);
          resolve(false);

        } else {
          if (!clinics.find((clinic: Partial<IClinic>) => clinic._id === paramClinicId)) {
            await firstValueFrom((this.store.dispatch(new AuthActions.GetUserMe(clinics[0]._id))));
            const user = this.storageService.getLocalItem<{ token: string, user: IUser }>('user')?.user;

            if (user.experts) { // Expert
              await this.router.navigate(['clinic', clinics[0]._id, 'summary']);
            } else if (user.patients) { // Patient
              if (user.patients[0].status === PatientStatusEnum.PRECREATED) {
                await this.router.navigate(['clinic', 'onboarding', clinics[0]._id]);
              } else {
                await this.router.navigate(['clinic', clinics[0]._id, 'summary']);
              }
            } else { // Admin
              await this.router.navigate(['clinic', clinics[0]._id, 'summary']);
            }
            resolve(false);
          } else {
            resolve(true);
          }
        }
      } catch (e) {
        console.log(e);
      }
    });
  }

}
